import React from 'react';
import { Col, Row } from 'react-bootstrap';
import packageJson from '../../../package.json';
import { getBuildDate } from '../../helpers/utils';

const Footer = () => {
    return (
        <footer className="footer fixed-bottom mt-auto py-2 bg-white shadow-lg border-top">
            <Col xs={12}>
                <Row>
                    <Col md={8} className="text-center text-md-left">
                        <span className="text-muted">
                            <small>&copy; 2022 - Dirección de Sistemas</small>
                        </span>
                    </Col>
                    <Col md={4} className="text-center text-md-right">
                        <span className="text-muted">
                            <small>v{ getBuildDate(packageJson.buildDate) }</small>
                        </span>
                    </Col>
                </Row>
            </Col>
        </footer>
    );
};

export default Footer;